/** Interpolated UI messages. Values remain untouched (including user content). */
export const dynamicEnglish: Record<string, string> = Object.fromEntries(`
{v0}的头像|Avatar of {v0}
{v0} 的头像|Avatar of {v0}
{v0}头像|Avatar of {v0}
{v0}的用户卡片|Profile of {v0}
{v0} 的用户卡片|Profile of {v0}
{v0} 的成员操作|Actions for {v0}
{v0}的个人资料|Profile of {v0}
{v0}的 Arkme 主页|{v0}'s Arkme profile
{v0}的世界暂时无法加载|Unable to load {v0}'s world
正在加载 {v0} 的世界…|Loading {v0}'s world…
进入{v0}的世界|Open {v0}'s world
{v0}的快记|{v0}'s notes
@{v0}的快记|Notes mentioning @{v0}
{v0}的{v1}条快记|{v1} notes from {v0}
{v0}和{v1}的快记|Notes between {v0} and {v1}
{v0}和{v1}的{v2}条快记|{v2} notes between {v0} and {v1}
{v0}条快记|{v0} notes
{v0} 条快记|{v0} notes
{v0} 条相关快记|{v0} related notes
{v0} 条原始记录|{v0} original records
{v0} 条评论|{v0} comments
{v0}{v1} 条评论|{v0}{v1} comments
{v0} 位成员|{v0} members
{v0} 个|{v0}
{v0}段|{v0} segments
{v0} 秒|{v0} s
{v0}秒|{v0}s
{v0} 分钟|{v0} min
{v0}分钟|{v0}min
{v0}小时|{v0}h
{v0}分{v1}秒|{v0}m {v1}s
{v0}小时{v1}分|{v0}h {v1}m
{v0} 分 {v1} 秒|{v0}m {v1}s
{v0} 分钟前|{v0} min ago
{v0} 小时前|{v0} h ago
{v0} 天前|{v0} days ago
{v0} 个月前|{v0} months ago
{v0} 年前|{v0} years ago
今天 {v0}|Today {v0}
昨天 {v0}|Yesterday {v0}
前天 {v0}|Two days ago {v0}
{v0}月{v1}日|{v0}/{v1}
跳转月份：{v0}|Jump to month: {v0}
{v0} 像素|{v0} px
来源：{v0}|Source: {v0}
私聊 {v0} 条|{v0} direct messages
群聊互动 {v0} 条|{v0} group interactions
查看地点：{v0}|View location: {v0}
查看小结来源：{v0}|View recap source: {v0}
已有录音，共 {v0} 个音频区间|Recorded audio: {v0} intervals
录音范围尚不完整，已知 {v0} 个音频区间|Partial recording coverage: {v0} known intervals
正在定位 {v0}…|Locating {v0}…
{v0}缩略图暂不可用|Thumbnail unavailable: {v0}
预览{v0}|Preview {v0}
{v0}，第 {v1} 个附件|{v0}, attachment {v1}
账户余额 {v0}|Account balance: {v0}
{v0}已用比例|{v0} used
本月已用 {v0} / 剩余 {v1} / 共 {v2} Token|This month: {v0} used / {v1} left / {v2} tokens total
已用 {v0} / 剩余 {v1} / 共 {v2}|{v0} used / {v1} left / {v2} total
本月已用 {v0} / 剩余 {v1} / 共 {v2}|This month: {v0} used / {v1} left / {v2} total
剩余 {v0}|{v0} remaining
每月 {v0}|{v0} per month
和 {v0} 打个招呼吧|Say hello to {v0}
{v0} Bot 对话|Chat with {v0} Bot
发消息给 {v0}|Message {v0}
发消息给@{v0}|Message @{v0}
发消息到 {v0}{v1}|Message {v0}{v1}
({v0}人)|({v0} members)
 ({v0}人)| ({v0} members)
正在给 {v0} 发消息|Messaging {v0}
发送到「{v0}」…|Send to {v0}…
{v0} 能干什么|What can {v0} do?
问问 {v0}...|Ask {v0}…
发送给 {v0}|Send to {v0}
已切换到 {v0}|Switched to {v0}
停止 Arko 任务失败：{v0}|Unable to stop Arko task: {v0}
加载 Arko 对话记录失败：{v0}|Unable to load Arko history: {v0}
刷新 Arko 对话记录失败：{v0}|Unable to refresh Arko history: {v0}
加载更早的 Arko 对话记录失败：{v0}|Unable to load earlier Arko history: {v0}
Bot 已创建，但无法打开私聊：{v0}|Bot created, but the conversation could not open: {v0}
删除后不可恢复。请输入「{v0}」确认删除：|This cannot be undone. Type “{v0}” to confirm deletion:
{v0} 将无法继续查看或发送群消息。|{v0} will no longer be able to view or send group messages.
{v0}的聊天预览|Chat preview: {v0}
摄像头启动失败：{v0}|Unable to start camera: {v0}
即我号：{v0} · |Arkme ID: {v0} ·
昵称：{v0}|Nickname: {v0}
即我号：{v0}|Arkme ID: {v0}
备注：{v0}|Remark: {v0}
{v0}，{v1} 条未读|{v0}, {v1} unread
{v0}，有未读消息，已免打扰|{v0}, unread messages, muted
{v0} 条未读|{v0} unread
已读 {v0} / 未读 {v1}|{v0} read / {v1} unread
{v0}，查看成员已读详情|{v0}, view read receipts
查看{v0}通话详情|View call details: {v0}
与{v0}通话|Call with {v0}
和{v0}语音通话|Voice call with {v0}
和{v0}视频通话|Video call with {v0}
直接和{v0}语音通话|Start voice call with {v0}
直接和{v0}视频通话|Start video call with {v0}
选择{v0}通话方式|Choose call type for {v0}
选择和{v0}的通话方式|Choose call type for {v0}
呼叫{v0}|Call {v0}
正在呼叫 {v0}…|Calling {v0}…
{v0}已挂断通话|{v0} ended the call
未接通 · {v0}|Not connected · {v0}
查看与{v0}的{v1}记录|View {v1} history with {v0}
向{v0}发起{v1}通话|Start a {v1} call with {v0}
选择联系人{v0}发起通话|Select {v0} to start a call
{v0} · 需先拥有私聊会话|{v0} · Start a direct conversation first
{v0} · 可发起通话|{v0} · Available to call
AI 摘要：{v0}|AI summary: {v0}
{v0}暂不可直接呼叫|{v0} cannot be called directly yet
{v0}的视角|{v0}'s view
播放{v0}|Play {v0}
播放{v0}在{v1}说的话|Play {v0} speaking at {v1}
暂停{v0}|Pause {v0}
重试播放{v0}|Retry playback: {v0}
正在加载{v0}|Loading {v0}
{v0}暂不可播放|{v0} is unavailable for playback
{v0}，时长 {v1}|{v0}, duration {v1}
{v0}的群聊头像|Group avatar of {v0}
{v0}的机器人头像|Bot avatar of {v0}
{v0}的说话人头像|Speaker avatar of {v0}
{v0}的团队头像|Team avatar of {v0}
{v0}的成员|Members of {v0}
{v0}暂时无法加载|Unable to load {v0}
{v0}权限未授权|{v0} permission not granted
{v0}不可用|{v0} unavailable
重试{v0}|Retry {v0}
正在上传{v0}|Uploading {v0}
发送{v0}|Send {v0}
选择 {v0}|Select {v0}
删除 {v0}|Delete {v0}
重试 {v0}|Retry {v0}
正在接收{v0}|Receiving {v0}
正在接收{v0} {v1}%|Receiving {v0} {v1}%
接收 {v0}|Receive {v0}
接收{v0}|Receive {v0}
下载{v0}|Download {v0}
文件预览 {v0}|File preview: {v0}
{v0}：附件准备失败|{v0}: unable to prepare attachment
{v0}：文件为空|{v0}: empty file
{v0} 为空或超过 {v1} MiB|{v0} is empty or exceeds {v1} MiB
最多添加 {v0} 个附件：{v1}|Up to {v0} attachments: {v1}
{v0} 仅聊天可发送|{v0} can only be sent in chat
向前移动第 {v0} 张预览图|Move preview {v0} earlier
向后移动第 {v0} 张预览图|Move preview {v0} later
删除第 {v0} 张预览图|Delete preview {v0}
查看第 {v0} 张预览图|View preview {v0}
{v0}的第 {v1} 张预览图|Preview {v1} of {v0}
展开另外 {v0} 个链接|Show {v0} more links
预览图片 {v0}|Preview image {v0}
{v0} 个评分|{v0} ratings
{v0} · {v1} 个评分|{v0} · {v1} ratings
{v0} 星|{v0} stars
回复{v0}|Reply to {v0}
回复 {v0}|Reply to {v0}
回复 {v0}…|Reply to {v0}…
{v0}的全部回复|All replies to {v0}
{v0}选项|{v0} options
全部 · {v0}|All · {v0}
{v0}风险|{v0} risk
评论 {v0}|Comments {v0}
查看 {v0}|Views {v0}
安装 {v0}|Installs {v0}
评分 {v0}|Rating {v0}
查看次数 {v0}|Views {v0}
{v0} 人已安装|{v0} users installed
查看扩展：{v0}|View extension: {v0}
Arkme 用户 {v0}|Arkme user {v0}
刷新失败，仍显示上次结果：{v0}|Refresh failed; showing previous results: {v0}
{v0} 的全部插件|All plugins by {v0}
清除作者 {v0} 筛选|Clear author filter: {v0}
分类：{v0}|Category: {v0}
排序：{v0}|Sort: {v0}
{v0} 套餐|{v0} plan
已转发 {v0} 个目标，{v1} 个失败，可重试|Forwarded to {v0}; {v1} failed. You can retry.
已转发 {v0} 个目标，{v1} 个失败|Forwarded to {v0}; {v1} failed
已转发到 {v0} 个目标|Forwarded to {v0} destinations
最多选择 {v0} 个转发对象|Select up to {v0} destinations
已选择 {v0} 条消息|{v0} messages selected
选择模型：{v0}|Choose model: {v0}
已记录位置（{v0}）|Location recorded ({v0})
已记录位置（{v0}，±{v1}m）|Location recorded ({v0}, ±{v1}m)
{v0} 至 {v1}|{v0} to {v1}
转发于 {v0}|Forwarded at {v0}
{v0}滚动条|{v0} scrollbar
成功删除 {v0} 条内容|Deleted {v0} items
已导出 {v0} 条内容，Markdown 文件已开始下载|Exported {v0} items. Downloading Markdown file.
已转发到 {v0} 个对象，{v1} 个失败|Forwarded to {v0}; {v1} failed
已转发到 {v0} 个对象|Forwarded to {v0} destinations
已处理 {v0} 条|Processed {v0} items
保存失败：{v0}|Unable to save: {v0}
{v0} 条快记或消息|{v0} notes or messages
读取 {v0}/{v1}|Loading {v0}/{v1}
解散中 {v0}/{v1}|Dissolving {v0}/{v1}
指定到{v0}|Move to {v0}
{v0}主题操作|Actions for topic {v0}
归入“{v0}”|Move into “{v0}”
提升为“{v0}”的子主题|Move under “{v0}”
正在读取快记 {v0} / {v1} 条…|Loading notes {v0} / {v1}…
正在迁移 {v0} / {v1} 条快记…|Moving notes {v0} / {v1}…
在{v0}下创建子主题|Create subtopic under {v0}
发给自己排序：{v0}|Notes sort: {v0}
{v0}的会话操作|Actions for conversation {v0}
最近更新：{v0}|Last updated: {v0}
正在录音 {v0} 秒|Recording {v0} s
录音已就绪 · {v0} 秒|Recording ready · {v0} s
第 {v0} 条消息|Message {v0}
{v0}加载失败|Unable to load {v0}
{v0}发布的图片 {v1}|Image {v1} posted by {v0}
{v0}发布的图片 1|Image 1 posted by {v0}
收起{v0}发布的全文|Collapse full post by {v0}
展开{v0}发布的全文|Expand full post by {v0}
回复{v0}的评论|Reply to comment by {v0}
{v0}的精选评论|Featured comments on {v0}'s post
打开{v0}的评论面板，共 {v1} 条评论|Open {v0}'s comments, {v1} total
查看{v0}的用户卡片|View {v0}'s profile
正在生成{v0}的声纹，点击停止|Generating {v0}'s voice. Click to stop
停止播放{v0}的声纹|Stop playing {v0}'s voice
播放{v0}的声纹|Play {v0}'s voice
邀请{v0}开启声纹|Invite {v0} to enable voiceprint
待发布图片 {v0}|Image to publish {v0}
移除图片 {v0}|Remove image {v0}
{v0}的评论区|Comments on {v0}'s post
已提醒 {v0} 开启声纹|Reminded {v0} to enable voiceprint
收到 {v0} 的消息|Message from {v0}
与 {v0} 的私聊|Direct chat with {v0}
与 {v0} 对话|Chat with {v0}
打开快记详情：{v0}|Open note: {v0}
打开群聊：{v0}|Open group: {v0}
实况 {v0}|Live photo {v0}
上传进度：{v0}%|Upload progress: {v0}%
上传进度 {v0}%|Upload progress: {v0}%
{v0}，点击查看导入任务|{v0}, click to view import tasks
同一批次不能包含同名录音：{v0}|Duplicate file names in this batch: {v0}
{v0}录音开始时间|Recording start time: {v0}
{v0}录音结束时间|Recording end time: {v0}
{v0}数据归属|Data owner: {v0}
处理耗时 {v0}|Processing time: {v0}
，已选择{v0}个|, {v0} selected
{v0}录音时长 {v1}|{v0}, duration {v1}
{v0}文件大小 {v1}|{v0}, size {v1}
{v0}处理耗时详情|Processing time details: {v0}
关闭 {v0}处理耗时详情|Close processing time details: {v0}
{v0}上传状态详情|Upload status: {v0}
编辑说话人 {v0}|Edit speaker {v0}
选择发送对象 {v0}|Select recipient {v0}
录音已停止，保存未完成：{v0}|Recording stopped; saving incomplete: {v0}
{v0}；录音仍保留在本机，可重试或下载|{v0}; recording remains on this device. Retry or download it.
参与者: {v0}|Participants: {v0}
说话人 {v0}|Speaker {v0}
`.trim().split('\n').map(line => { const p = line.indexOf('|'); return [line.slice(0, p), line.slice(p + 1)] }))
